import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { REPORT } from "../config/apiEndPoint";
import { POST } from "config/api.config";

/** POST `Report/sme-performance/filter` — body `{ year }`. */
export const submitSmePerformanceReportFilterData = async (data = {}) => {
    try {
        const response = await POST(REPORT.SME_PERFORMANCE_FILTER, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
